import { useDispatch } from "react-redux";
import { setQuestionViewAction } from "../../redux/answeringQuestions/questionView";
import useLocalStorage from "../useLocalStorage";

const useScribbleTooltip = () => {

  const dispatch = useDispatch();
  const setQuestionView = payload => { dispatch( setQuestionViewAction( payload ) ) };

  const { userData, setUserData } = useLocalStorage();

  const showScribbleTooltip = () => {
    userData.scribbleTooltipHiddenDate !== getScribbleTooltipHiddenDate() && setQuestionView( { scribbleTooltipStatus : 1 } );
  };

  const hideScribbleTooltip = () => {
    setUserData( { scribbleTooltipHiddenDate : getScribbleTooltipHiddenDate() } );
    setQuestionView( { scribbleTooltipStatus : 0 } );
  };

  const getScribbleTooltipHiddenDate = () => {
    const date = new Date();
    return `${ date.getFullYear() }.${ date.getMonth() + 1 }.${ date.getDate() }`;
  };

  return {
    showScribbleTooltip,
    hideScribbleTooltip
  };

};

export default useScribbleTooltip;
